import { ContactEmail } from '@base/common/Contact';
import styles from '@pro/help/default.module.less';

export default function WrongItemReceived() {
    return (
        <div className={styles.help}>
            <h1>Falscher Artikel erhalten</h1>
            <p>Wenn wir Ihnen etwas geschickt haben, das Sie nicht bestellt haben, möchten wir Ihnen den richtigen Artikel so schnell wie möglich zusenden.</p>
            <p><strong>Um loszulegen:</strong></p>
            <ul>
                <li>1) Schicken Sie uns eine E-Mail an
                    <ContactEmail/> mit deiner Bestellnummer
                </li>
                <li>2) Senden Sie uns die Bilder des falschen Produkts, das Sie erhalten haben, und fügen Sie alle Etiketten hinzu, die auf dem Versandkarton kleben</li>
                <li>3) Wählen Sie Ihre bevorzugte Lösung (Rückerstattung oder Ersatz)</li>
                <li>4) Wir geben Anweisungen zur Rücksendung</li>
            </ul>
            <p>Stellen Sie sicher, dass Sie diesen Vorgang innerhalb von <strong>30 Tage</strong> des Liefertermins.</p>
        </div>
    )
};